import { NgModule } from '@angular/core';

import { BookingsApiSettingsComponent }      from './bookings.api-settings.component';
import { BookingApiSettingsService }         from './bookings.api-settings.service';
import { BookingsRequestSendEmailComponent } from './bookings.request.send-email.component';
import { BookingsRequestSendSmsComponent }   from './bookings.request.send-sms.component';
import { SharedModule }                      from '../shared/shared.module';

@NgModule({
  declarations: [
    BookingsApiSettingsComponent,
    BookingsRequestSendEmailComponent,
    BookingsRequestSendSmsComponent
  ],
  entryComponents: [
    BookingsApiSettingsComponent,
    BookingsRequestSendEmailComponent,
    BookingsRequestSendSmsComponent
  ],
  exports: [
    BookingsApiSettingsComponent
  ],
  imports: [
    SharedModule
  ],
  providers: [
    BookingApiSettingsService
  ]
})
export class BookingsModule {}
